// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d8a5a68","455":"8220503f","488":"09d2cfc7"}[chunkId] + ".chunk.js";
};